import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IOwner } from '@/contracts/system-modules/share/IOwner'

export class GetOwnersRoute extends ShareRoute<null, IOwner[]> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/share/owners'
  }

  /** Без сервера никто зон не открывал */
  offline(): Promise<ApiResponse<IOwner[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
